webpackJsonp([63],{

/***/ 1037:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClbStepTemplateForm_vue__ = __webpack_require__(2560);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a14f84f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClbStepTemplateForm_vue__ = __webpack_require__(3403);
function injectStyle (ssrContext) {
  __webpack_require__(3397)
  __webpack_require__(3399)
  this["$style"] = __webpack_require__(3401)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a14f84f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClbStepTemplateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a14f84f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClbStepTemplateForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateForm_vue__ = __webpack_require__(2987);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c9fd82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateForm_vue__ = __webpack_require__(5426);
function injectStyle (ssrContext) {
  __webpack_require__(5420)
  __webpack_require__(5422)
  this["$style"] = __webpack_require__(5424)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22c9fd82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepTemplateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c9fd82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepTemplateForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  props: {},
  provide: function provide() {
    return {
      request: {
        table: 'getClbStepTemplateTable',
        detail: 'getClbStepTemplateDetail',
        create: 'createClbStepTemplateData',
        update: 'updateClbStepTemplateData'
      },
      scope: 'clb',
      create: this.create,
      update: this.update,
      visibleGuide: false
    };
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    create: function create(form) {
      var _this = this;

      request.common('createClbStepTemplateData', form).then(function (_ref) {
        var data = _ref.data;

        _this.$confirm(_this.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this.$refs.workspace.onReload();
        }, function () {
          _this.$router.push({ path: '/clb-step-template/update/' + data.id });
        });
      });
    },
    update: function update(id, form) {
      var _this2 = this;

      request.common('updateClbStepTemplateData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: id }, form)).then(function (_ref2) {
        var data = _ref2.data;

        _this2.$alert(_this2.$route.meta.title + '成功!', '提示', { type: 'success' }).then(function () {
          _this2.$router.push({ path: '/clb-step-template/update/' + id });
        });
      });
    }
  },
  filters: {}
});

/***/ }),

/***/ 2987:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  props: {},
  provide: function provide() {
    return {
      request: {
        table: 'getStepTemplateTable',
        detail: 'getStepTemplateDetail',
        create: 'createStepTemplateData',
        update: 'updateStepTemplateData'
      },
      scope: '',
      create: this.create,
      update: this.update,
      visibleGuide: true
    };
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: {
    create: function create(form) {
      var _this = this;

      var stepForm = this.stepFormData(filter.copyJson(form));
      request.common('createStepTemplateData', stepForm).then(function (res) {
        _this.$confirm(_this.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this.$refs.workspace.onReload();
        }, function () {
          _this.$router.push({ path: '/step-template/table/' });
        });
      });
    },
    update: function update(id, form) {
      this.updataStepData(id, form);
    },
    updataStepData: function updataStepData(id, form) {
      var _this2 = this;

      var stepForm = this.stepFormData(filter.copyJson(form));
      request.common('updateStepTemplateData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, stepForm)).then(function (res) {
        _this2.$confirm(_this2.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this2.$router.push({ path: '/step-template/table/' });
        });
      });
    },
    stepFormData: function stepFormData(form) {
      var questions = JSON.parse(form.json);
      questions.forEach(function (item) {
        delete item.keyin_ids;
      });
      form.json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(questions);
      return form;
    },
    keyinFormData: function keyinFormData(id, form) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ tpl_id: id }, form, { origin_json: form.json });
    }
  },
  filters: {}
});

/***/ }),

/***/ 3397:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3398);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("57024f09", content, true, {});

/***/ }),

/***/ 3398:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ClbStepTemplateForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3399:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3400);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("f1a2c6d6", content, true, {});

/***/ }),

/***/ 3400:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ClbStepTemplateForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3401:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4df1eeff", content, true, {});

/***/ }),

/***/ 3402:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ClbStepTemplateForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{ref:"workspace"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5420:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("51b8d485", content, true, {});

/***/ }),

/***/ 5421:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5422:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5423);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("bd7e8cee", content, true, {});

/***/ }),

/***/ 5423:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5424:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5425);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1308600a", content, true, {});

/***/ }),

/***/ 5425:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"StepTemplateForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{ref:"workspace"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/step-template-form.291a7e0775cef4d68880.js